import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import '@fancyapps/fancybox/dist/fancybox.css';
// import { Fancybox } from '@fancyapps/fancybox';
function Productdetails() {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // useEffect(() => {
  //   Fancybox.bind('[data-fancybox]', {
  //     // Fancybox options here
  //     // Ensure the function runs when the component mounts
  //     beforeShow: () => {
  //       // This will advance the Slick slider to the next slide
  //       document.querySelector('.tm-prodetails-largeimages .slick-next').click();
  //     }
  //   });
  // }, []);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  const slider3 = {
    infinite: !0,
    autoplay: !0,
    pauseOnHover: 1,
    speed: 2e3,
    autoplaySpeed: 5e3,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: !1,
    dots: !1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    ],
  };
  return (
    <div>
      <main className="page-content">
        <div className="tm-product-details-area tm-section tm-padding-section bg-white wishlist-section-ones wwaaaa">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-12 ">
                <div className="tm-prodetails prodetails-three ">
                  <div className="row">
                    <div className="col-lg-5 col-md-6 col-sm-10 col-12 ">
                      <div className="tm-prodetails-images sticky-top1">
                        <Slider
                          asNavFor={nav2}
                          ref={(slider) => (sliderRef1 = slider)}
                          arrows={false}
                          fade={true}
                          loop={false}
                          className="tm-prodetails-largeimages"
                        >
                          <div className="tm-prodetails-largeimage">
                            <a
                              data-fancybox="tm-prodetails-imagegallery"
                              href="assets/images/slide-1.png"
                              data-caption="Product Zoom Image 1"
                            >
                              <img
                                src="assets/images/slide-1.png"
                                alt="product image"
                              />
                            </a>
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <a
                              data-fancybox="tm-prodetails-imagegallery"
                              href="assets/images/slide-2.png"
                              data-caption="Product Zoom Image 2"
                            >
                              <img
                                src="assets/images/slide-2.png"
                                alt="product image"
                              />
                            </a>
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <a
                              data-fancybox="tm-prodetails-imagegallery"
                              href="assets/images/slide-3.png"
                              data-caption="Product Zoom Image 3"
                            >
                              <img
                                src="assets/images/slide-3.png"
                                alt="product image"
                              />
                            </a>
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <a
                              data-fancybox="tm-prodetails-imagegallery"
                              href="assets/images/slide-4.png"
                              data-caption="Product Zoom Image 4"
                            >
                              <img
                                src="assets/images/slide-4.png"
                                alt="product image"
                              />
                            </a>
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <a
                              data-fancybox="tm-prodetails-imagegallery"
                              href="assets/images/slide-5.png"
                              data-caption="Product Zoom Image 5"
                            >
                              <img
                                src="assets/images/slide-5.png"
                                alt="product image"
                              />
                            </a>
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <a
                              data-fancybox="tm-prodetails-imagegallery"
                              href="assets/images/slide-6.png"
                              data-caption="Product Zoom Image 6"
                            >
                              <img
                                src="assets/images/slide-6.png"
                                alt="product image"
                              />
                            </a>
                          </div>
                        </Slider>

                        <Slider
                          asNavFor={nav1}
                          ref={(slider) => (sliderRef2 = slider)}
                          slidesToShow={4}
                          swipeToSlide={true}
                          focusOnSelect={true}
                          arrows={false}
                          className="tm-prodetails-thumbnails"
                        >
                          <div className="tm-prodetails-thumbnail">
                            <img
                              src="assets/images/slide-1.png"
                              alt="product image"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              src="assets/images/slide-2.png"
                              alt="product image"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              src="assets/images/slide-3.png"
                              alt="product image"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              src="assets/images/slide-4.png"
                              alt="product image"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              src="assets/images/slide-5.png"
                              alt="product image"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              src="assets/images/slide-6.png"
                              alt="product image"
                            />
                          </div>
                        </Slider>
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-6 col-12 sticky-top2">
                      <div className="tm-prodetails-content">
                        <h4 className="tm-prodetails-title">{t("PD1")}</h4>
                        <span className="tm-prodetails-price">
                          ₹ 1259.99<del>₹ 1775.99</del>
                        </span>
                        <div
                          id="starrat"
                          className="tm-ratingbox ratingbox-one starrate"
                          data-val="2.5"
                          data-max={5}
                        >
                          <a href="#revard1">
                            <span className="is-active-one">4.5</span>
                            <span>
                              <i className="ion-android-star-outline star-outline-one" />
                            </span>
                          </a>
                        </div>
                        <span className="reviews-text">{t("PD2")}</span>
                        <div
                          className="products-ditales-one1 products-ditales11"
                          style={{ width: "100% !important" }}
                        >
                          <div className="products-ditales-one">
                            <div className="size-text">
                              <div className="widgets-one">
                                <h2>
                                  <b> {t("PD3")}</b>
                                </h2>
                                <h3>
                                  <select className="Weight-text">
                                    <option>S</option>
                                    <option>M</option>
                                    <option>L</option>
                                    <option>XL</option>
                                    <option>XXL</option>
                                  </select>
                                </h3>
                              </div>
                              <div className="widgets-one">
                                <h2>
                                  <b>{t("PD4")}</b>
                                </h2>
                                <h3>
                                  <select className="Weight-text">
                                    <option>{t("PD45")}</option>
                                    <option>{t("PD46")}</option>
                                    <option>{t("PD47")}</option>
                                    <option>{t("PD48")}</option>
                                    <option>{t("PD49")}</option>
                                  </select>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tm-prodetails-quantitycart button-wishlist">
                          <Link to="/cart" className="tm-button-cart">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 576 512"
                            >
                              {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                              <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
                            </svg>
                            {t("PD5")}
                          </Link>
                          <Link
                            to="/wishlist"
                            className="tm-button-wishlist1 tm-button-wishlist2"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                            >
                              {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                              <path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z" />
                            </svg>
                            {t("PD6")}
                          </Link>
                        </div>
                        <div className="products-ditales-text">
                          <div className="products-ditales-one">
                            <h6> {t("PD7")}</h6>
                            {/* <div class="Address-address-box Address-pincode-input Address-pdp-box"><input type="tel" placeholder="Enter a PIN code" value=""><button type="submit" class="Address-address-button" style="color: rgb(191, 192, 198);">CHECK</button></div> */}
                            <p>{t("PD8")}</p>
                            <p> {t("PD9")}</p>
                            <p> {t("PD10")}</p>
                            <p> {t("PD11")}</p>
                          </div>
                        </div>
                        <div className="products-ditales-text products-ditales-one1">
                          <div className="products-ditales-one">
                            <h6> {t("PD12")}</h6>
                            <p> {t("PD13")}</p>
                            <p> {t("PD14")}</p>
                            <p> {t("PD15")}</p>
                            <p> {t("PD16")}</p>
                          </div>
                        </div>
                        <div className="products-ditales-text products-ditales-one1">
                          <div className="products-ditales-one">
                            <h6> {t("PD17")}</h6>
                            <p> {t("PD18")}</p>
                            <p> {t("PD19")}</p>
                            <p> {t("PD20")}</p>
                          </div>
                        </div>
                        <div className="products-ditales-text products-ditales-one1">
                          <div className="products-ditales-one">
                            <h6> {t("PD21")}</h6>
                            <p>
                              {t("PD22")}
                              <br /> {t("PD23")}
                            </p>
                          </div>
                        </div>
                        <div className="products-ditales-text products-ditales-one1">
                          <div className="products-ditales-one">
                            <h6> {t("PD24")}</h6>
                            <div className="row">
                              <div className="col-lg-6 col-md-6">
                                <div className="left-box1">
                                  <p> {t("PD25")}</p>
                                  <h6> {t("PD26")}</h6>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="left-box1">
                                  <p> {t("PD27")}</p>
                                  <h6> {t("PD28")}</h6>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="left-box1">
                                  <p> {t("PD29")}</p>
                                  <h6> {t("PD30")}</h6>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="left-box1">
                                  <p>                        {t("PD31")}
                                  </p>
                                  <h6>                        {t("PD32")}
                                  </h6>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="left-box1">
                                  <p>                        {t("PD33")}
                                  </p>
                                  <h6>                        {t("PD34")}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="revard1"
                          className="products-ditales-text products-ditales-one1"
                        >
                          <div className="products-ditales-one products-retting">
                            <h6>
                            {t("PD35")}

                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512"
                              >
                                {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
                              </svg>
                            </h6>
                            <div
                              className="row row-center"
                              style={{ paddingTop: "20px !important" }}
                            >
                              <div className="col-lg-6 col-md-6">
                                <div className="left-box2">
                                  <h6>
                                    4.4
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 576 512"
                                    >
                                      {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                      <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                                    </svg>
                                  </h6>
                                  <p>                        {t("PD36")}
                                  </p>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="left-box2">
                                  <div className="side">
                                    <div>
                                      5{" "}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 576 512"
                                      >
                                        {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                        <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="middle">
                                    <div className="bar-container">
                                      <div className="bar-5" />
                                    </div>
                                  </div>
                                  <div className="side right">
                                    <div>150</div>
                                  </div>
                                  <div className="side">
                                    <div>
                                      4{" "}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 576 512"
                                      >
                                        {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                        <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="middle">
                                    <div className="bar-container">
                                      <div className="bar-4" />
                                    </div>
                                  </div>
                                  <div className="side right">
                                    <div>63</div>
                                  </div>
                                  <div className="side">
                                    <div>
                                      3{" "}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 576 512"
                                      >
                                        {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                        <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="middle">
                                    <div className="bar-container">
                                      <div className="bar-3" />
                                    </div>
                                  </div>
                                  <div className="side right">
                                    <div>15</div>
                                  </div>
                                  <div className="side">
                                    <div>
                                      2{" "}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 576 512"
                                      >
                                        {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                        <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="middle">
                                    <div className="bar-container">
                                      <div className="bar-2" />
                                    </div>
                                  </div>
                                  <div className="side right">
                                    <div>6</div>
                                  </div>
                                  <div className="side">
                                    <div>
                                      1{" "}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 576 512"
                                      >
                                        {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                        <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="middle">
                                    <div className="bar-container">
                                      <div className="bar-1" />
                                    </div>
                                  </div>
                                  <div className="side right">
                                    <div>20</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12">
                            <div
                              className="all-view"
                              style={{ textAlign: "right" }}
                            >
                              <div>
                                <button
                                  className
                                  type="button"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#offcanvasScrolling222"
                                  aria-controls="offcanvasScrolling"
                                >
                                  <a href="#">                        {t("PD37")}
                                  </a>
                                </button>
                                <div
                                  className="offcanvas offcanvas-end offcanvas-copy"
                                  data-bs-scroll="true"
                                  data-bs-backdrop="false"
                                  tabIndex={-1}
                                  id="offcanvasScrolling222"
                                  aria-labelledby="offcanvasScrollingLabel"
                                >
                                  <div className="offcanvas-header offcanvas-header-two">
                                    <h5 id="offcanvasRightLabel">
                                    {t("PD38")}

                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close btn-close-one text-reset"
                                      data-bs-dismiss="offcanvas"
                                      aria-label="Close"
                                    />
                                  </div>
                                  <div className="offcanvas-body reviews-btn-text">
                                    <div className="row row-two">
                                      <div className="col-lg-2 col-2">
                                        <div className="reviews-custombr-text">
                                          <div
                                            className="tm-ratingbox ratingbox-one ratingbox22 ratingbox-three starrate"
                                            data-val="2.5"
                                            data-max={5}
                                          >
                                            <a href="#revard1">
                                              <span className="is-active-one is-active22">
                                                5
                                              </span>
                                              <span>
                                                <i className="ion-android-star-outline star-outline-one star-outline22" />
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-10 col-10">
                                        <div className="reviews-custombr-text reviews-custombr-right">
                                        {t("PD39")}

                                        </div>
                                        <div className="customber-neme">
                                          <span>                        {t("PD40")}
                                          </span>
                                          <span>                        {t("PD41")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-two">
                                      <div className="col-lg-2 col-2">
                                        <div className="reviews-custombr-text">
                                          <div
                                            className="tm-ratingbox ratingbox22 ratingbox-one ratingbox-three starrate"
                                            data-val="2.5"
                                            data-max={5}
                                          >
                                            <a href="#revard1">
                                              <span className="is-active-one is-active22">
                                                5
                                              </span>
                                              <span>
                                                <i className="ion-android-star-outline star-outline-one star-outline22" />
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-10 col-10">
                                        <div className="reviews-custombr-text reviews-custombr-right">
                                        {t("PD39")}

                                        </div>
                                        <div className="customber-neme">
                                          <span>                        {t("PD40")}
                                          </span>
                                          <span>                        {t("PD41")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-two">
                                      <div className="col-lg-2 col-2">
                                        <div className="reviews-custombr-text">
                                          <div
                                            className="tm-ratingbox ratingbox22 ratingbox-one ratingbox-three starrate"
                                            data-val="2.5"
                                            data-max={5}
                                          >
                                            <a href="#revard1">
                                              <span className="is-active-one is-active22">
                                                5
                                              </span>
                                              <span>
                                                <i className="ion-android-star-outline star-outline-one star-outline22" />
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-10 col-10">
                                        <div className="reviews-custombr-text reviews-custombr-right">
                                        {t("PD39")}

                                        </div>
                                        <div className="customber-neme">
                                          <span>                        {t("PD40")}
                                          </span>
                                          <span>                        {t("PD41")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-two">
                                      <div className="col-lg-2 col-2">
                                        <div className="reviews-custombr-text">
                                          <div
                                            className="tm-ratingbox ratingbox22 ratingbox-one ratingbox-three starrate"
                                            data-val="2.5"
                                            data-max={5}
                                          >
                                            <a href="#revard1">
                                              <span className="is-active-one is-active22">
                                                5
                                              </span>
                                              <span>
                                                <i className="ion-android-star-outline star-outline-one star-outline22" />
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-10 col-10">
                                        <div className="reviews-custombr-text reviews-custombr-right">
                                        {t("PD39")}

                                        </div>
                                        <div className="customber-neme">
                                          <span>                        {t("PD40")}
                                          </span>
                                          <span>                        {t("PD41")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tm-product-details-area tm-section tm-padding-section bg-white wishlist-section-ones">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-12">
                <div className="tm-similliar-products">
                  <h4 className="small-title">                        {t("PD44")}
                  </h4>
                  <Slider
                    {...slider3}
                    className="row tm-products-slider3 similliar-products"
                  >
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-1.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-2.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-3.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-4.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-5.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-55.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-6.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-66.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-7.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-77.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-8.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-88.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges">
                              <span className="tm-product-badges-new">
                                Sale
                              </span>
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-9.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-99.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="tm-product tm-scrollanim">
                        <Link to="/Productdetails" onClick={handleLinkClick}>
                          <div className="tm-product-topside">
                            <div className="tm-product-images product-images-two">
                              <img
                                src="assets/images/product-image-10.jpg"
                                alt="product image"
                              />
                              <img
                                src="assets/images/product-image-110.jpg"
                                alt="product image"
                              />
                            </div>
                            <div className="tm-product-badges1">
                              <span className="tm-product-badges-new">
                                4.5
                                <i className="ion-android-star-outline star-outline-one" />
                              </span>
                            </div>
                            <div className="tm-product-badges2">
                              <span className="product-badges-size">S</span>
                              <span className="product-badges-size">M</span>
                              <span className="product-badges-size">L</span>
                              <span className="product-badges-size">XL</span>
                              <span className="product-badges-size">XXL</span>
                            </div>
                          </div>
                          <div className="tm-product-bottomside">
                            <h6 className="tm-product-title">
                             {t("Product description")}                            </h6>
                            <span className="tm-product-price-two">
                              <b>₹1,199</b>
                            </span>
                            <span className="product-price-three tm-product-price-two">
                              ₹1,999
                            </span>
                            <span className="product-price-four">40% OFF</span>
                            <ul className="products-color">
                              <li className="products-color-a" />
                              <li className="products-color-b" />
                              <li className="products-color-c" />
                              <li className="products-color-d" />
                              <li className="products-color-e" />
                              <li className="products-color-f" />
                              <li className="products-color-g" />
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Productdetails;
